import transformToCamelCase from '../../shared/transformers/toCamelCaseTransformer';

export default function transformTables({ columns = [], data = [] }) {
  const transformedColumns = columns.map(column =>
    transformToCamelCase(column),
  );
  return {
    columns: transformedColumns,
    data,
  };
}
